import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  AfdrachtsVermindering,
  BelastNormaalTarief,
  BelastVerdragsTarief,
  BokkzAlgDataService, BokkzDivDataService, BokkzDivLogic,
  Dividendbelasting,
  DividendTaxEntity, Fonds, InhoudingsVrijstelling,
  LiquidatieUitkering
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import {SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {Subscription} from "rxjs";

@Component({
  selector: 'snelstart-venture-fiscaal-voorkomingdividend',
  standalone: true,
  imports: [CommonModule, SharedUiDetailsModule, SharedUiFormControlsModule],
  templateUrl: './voorkoming.component.html',
  styleUrl: './voorkoming.component.scss',
})
export class VoorkomingComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private divTaxEntitySubscription: Subscription | undefined;
  public divTaxEntity = {} as DividendTaxEntity;
  public aangifte = {} as Dividendbelasting;
  public dividendFg = {} as FormGroup;
  public afdrachtsVerminderingFg = {} as FormGroup;
  public index = 0;
  public formStructure: any;
  public focusedElementId: string | null = null;

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzDivDataService,
    public divService: BokkzDivLogic,
    private fb: FormBuilder) {
    this.dividendFg = this.fb.group({
      subfund: null as unknown as Fonds,
      bedragDividenduitkering: null as unknown as number,
      bedragOnbelastVerbodExtraterritorialeHeffing: null as unknown as number,
      liquidatieUitkering: null as unknown as LiquidatieUitkering,
      inhoudingsVrijstelling: null as unknown as InhoudingsVrijstelling,
      belastVerdragsTarief: null as unknown as BelastVerdragsTarief,
      belastNormaalTarief: null as unknown as BelastNormaalTarief,
      afdrachtsVermindering: null as unknown as AfdrachtsVermindering,
    })
    this.afdrachtsVerminderingFg = this.fb.group<AfdrachtsVermindering>({
      bedragVerminderingArtikel11: null as unknown as number,
      bedragIngehoudenBelastingArtikel11a: null as unknown as number,
      bedragIngehoudenBuitenlandseBronbelasting: null as unknown as number,
      bedragIngehoudenBelastingArtikel12: null as unknown as number,
      bedragVerminderingArtikel12: null as unknown as number,
    })
  }

  ngOnInit(): void {
    this.divTaxEntitySubscription = this.dataService.dividendTaxEntity.subscribe((value) => {
      this.divTaxEntity = value;
      this.aangifte = value.aangifte!;
      if (this.aangifte.aangifteDb?.dividendSpecificaties?.at(0)) {
        this.dividendFg.patchValue(this.aangifte.aangifteDb?.dividendSpecificaties[0], {emitEvent: false})
      }
      if (this.aangifte.aangifteDb?.dividendSpecificaties?.at(0)?.afdrachtsVermindering!) {
        this.afdrachtsVerminderingFg.patchValue(this.aangifte.aangifteDb?.dividendSpecificaties?.at(0)?.afdrachtsVermindering!, {emitEvent: false})
      }
    })
  }

  ngOnDestroy(): void {
    if (this.divTaxEntitySubscription) {
      this.divTaxEntitySubscription.unsubscribe()
    }
  }

  saveForm(): void {
    this.dividendFg.updateValueAndValidity({ emitEvent: false })
    this.afdrachtsVerminderingFg.updateValueAndValidity({ emitEvent: false })
    this.dividendFg.value.afdrachtsVermindering = this.afdrachtsVerminderingFg.value;
    this.divTaxEntity.aangifte = {
      ...this.aangifte,
      aangifteDb: {
        ...this.aangifte.aangifteDb,
        dividendSpecificaties: [this.dividendFg.value],
      }
    } as Dividendbelasting;
    this.dataService.updateDividendTaxEntity(this.divTaxEntity);
    this.divService.getCalculation(this.divTaxEntity);
  }
}
